import styled from "styled-components";
import { Modal as AntModal, } from 'antd';

export const Modal = styled(AntModal)`

@media screen and (max-width: 350px) {
  width: 400px !important;
  height: 400px !important;
}
`;

export const ModalTitle = styled.p`
  color: #71207c;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const ModalLabel = styled.p`
  font-size: 14px;
  text-align: center;
`;

export const StyledInput = styled.input`
  width: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#E1CCE0")} !important;
  font-size: 17px !important;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 30px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 25px !important;
  }
`;
